import Vue from "vue";

let sdsUiEnable = false;

if (typeof Drupal !== "undefined") {
  // BioRAFT 3.
  if (Drupal.settings) {
    if (
      Drupal.settings.hasOwnProperty("chemtracker") &&
      Drupal.settings.chemtracker.hasOwnProperty("chemical_sds_ui_enabled")
    ) {
      sdsUiEnable = Drupal.settings.chemtracker.chemical_sds_ui_enabled;
    }
  }
  // BioRAFT 4.
  if (typeof drupalSettings !== "undefined" && drupalSettings.user) {
    if (drupalSettings.chemtracker) {
      if (drupalSettings.chemtracker.chemical_sds_ui_enabled) {
        sdsUiEnable = true;
      }
    }
  }
}

const state = {
  showSdsModal: false,
  sdsModalTitle: "Assign SDS to Container",
  sdsUiEnable: sdsUiEnable,
  selectedSdsDocumentId: null,
  selectedSdsEntityUuid: null,
  selectedSdsEntityType: null,
  selectedContainer: null,
  sdsBulkAssignStatus: {},
};

const mutations = {
  setShowSdsModal: (state, showSdsModal) => (state.showSdsModal = showSdsModal),
  setSdsModalTitle: (state, title) => (state.sdsModalTitle = title),
  setSelectedSdsDocumentId: (state, documentId) =>
    (state.selectedSdsDocumentId = documentId),
  setSelectedSdsEntityUuid: (state, uuid) =>
    (state.selectedSdsEntityUuid = uuid),
  setSelectedSdsEntityType: (state, type) =>
    (state.selectedSdsEntityType = type),
  setSelectedContainer: (state, container) =>
    (state.selectedContainer = container),
  setSdsBulkAssignStatus: (state, bulkAssignStatus) =>
    (state.sdsBulkAssignStatus = bulkAssignStatus),
};

const getters = {
  getShowSdsModal: (state) => state.showSdsModal,
  getSdsModalTitle: (state) => state.sdsModalTitle,
  getSdsUiEnabled: (state) => state.sdsUiEnable,
  getSelectedSdsDocumentId: (state) => state.selectedSdsDocumentId,
  getSelectedSdsEntityUuid: (state) => state.selectedSdsEntityUuid,
  getSelectedSdsEntityType: (state) => state.selectedSdsEntityType,
  getSelectedContainer: (state) => state.selectedContainer,
  getSdsBulkAssignStatus: (state) => state.sdsBulkAssignStatus,
};

const actions = {
  updateShowSdsModal({ commit }, value) {
    commit("setShowSdsModal", value);
  },
  updateSelectedSdsDocumentId({ commit }, value) {
    commit("setSelectedSdsDocumentId", value);
  },
  updateSelectedSdsEntityUuid({ commit }, value) {
    commit("setSelectedSdsEntityUuid", value);
  },
  updateSelectedSdsEntityType({ commit }, value) {
    commit("setSelectedSdsEntityType", value);
  },
  updateSelectedContainer({ commit }, value) {
    commit("setSelectedContainer", value);
  },
  updateSdsModalTitle({ commit }, value) {
    commit("setSdsModalTitle", value);
  },
  updateSdsBulkAssignStatus({ commit }, value) {
    commit("setSdsBulkAssignStatus", value);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
